/* eslint-disable no-unused-vars */
export const enum WeekParity {
  Even = 'even',
  Odd = 'odd',
}

export const evenNames: string[] = [
  'четтн',
  'чет',
  'четн',
  'четная',
  'ч',
  'чёттн',
  'чёт',
  'чётн',
  'чётная',
];

export const oddNames: string[] = [
  'нечеттн',
  'нечет',
  'нечетн',
  'нечетная',
  'нч',
  'неч',
  'нечёттн',
  'нечёт',
  'нечётн',
  'нечётная',
];
